/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2025 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/

import { AnalyticsBrowser } from "@customerio/cdp-analytics-browser";

let _cioanalytics: any = {
  page: () => {},
  //TODO: Merge AjoSdk into this when implementing trackEvent
  //track: () => {},
  identify: () => {},
};

const isTest = JSON.parse(process.env.IS_TEST ?? "false");
const isSnapshot = navigator.userAgent === "ReactSnap";
const CUSTOMER_IO_WRITE_KEY = process.env.CUSTOMER_IO_WRITE_KEY;
const CUSTOMER_IO_SITE_ID = process.env.CUSTOMER_IO_SITE_ID;

export const loadCustomerPersonalization: VoidFunction = () => {
  // Load Customer.io analytics
  if (!isTest && !isSnapshot && CUSTOMER_IO_WRITE_KEY && CUSTOMER_IO_SITE_ID) {
    _cioanalytics = AnalyticsBrowser.load(
      { writeKey: CUSTOMER_IO_WRITE_KEY },
      {
        integrations: {
          "Customer.io In-App Plugin": {
            siteId: CUSTOMER_IO_SITE_ID,
          },
        },
      }
    );
    _cioanalytics.page();
  }
};

// Identify the customer in our personalization services.
//
// NOTE: Adding traits/profile attributes to the customer
// is done using the CustomerPersonalizationEnrichmentJob.
export const identifyCustomer = (email: string): void => {
  _cioanalytics.identify(email);
};
